<template>
    <aside :show.sync="show" placement="right" header="修改团队状态" :width="400">
    <form>
      <h4 class="text-center">【{{trip.catalog}}】{{trip.heading}}</h4>
      <div class="alert alert-danger" role="alert">Attention : 修改团状态会引起诸多连锁反应，请谨慎操作！</div>
      <div class="form-group">
        <label class="control-label">操作</label>
        <select class="form-control" v-model="trip.status">
          <option v-for="(key, val) in tripDBStatus" track-by="$index" :value="key">{{val}}</option>
        </select>
      </div>
      <div class="from-group text-center">
        <button class="btn btn-primary" type="button" @click="click(submit)($event)">提交</button>
      </div>
    </form>
  </aside>
</template>

<script>
  import { aside } from 'vue-strap'
  import config from '../../libs/config'
  import utils from '../../libs/utils'
  import { pick } from 'lodash'

  export default {
    components: {
      aside
    },
    props: {
      trip: {
        required: true,
        type: Object
      },
      show: {
        required: true,
        twoWay: true
      }
    },
    data () {
      return {
        tripDBStatus: config.tripDBStatus
      }
    },
    methods: {
      submit () {
        let data = pick(this.trip, [
          'status'
        ])
        return this.$http.put(`${config.apiWe}/product/trip/${this.trip.id}/status`, data)
          .then(() => {
            this.show = false
            this.$dispatch('callback')
          })
      },
      click: utils.click
    }
  }
</script>

<style>

</style>



/** WEBPACK FOOTER **
 ** EditStatus.vue?66fa8b8b
 **/